/*eslint-disable*/
/* IMPORT MODULE */
import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import { Modal as ModalReactstrap } from "reactstrap";
import { withRouter } from "react-router-dom";

/* IMPORT UTILS */
import {
  emptyImage,
  getCloudImageUrl,
  convertToRupiah,
  parsePhone,
  parsePhoneCode,
  VOUCHER_COURIER_TYPE,
  VOUCHER_PRODUCT_TYPE,
  capitalizeFirstLetter,
} from "../../../utils";
import { formatCurrency, printErrorNew } from "../../../utils/Helpers";
import { useOtpStorage } from "../../../helpers/dom";
import { validateUmbre } from "../../../config/umbre";

/* ACTIONS */
import { getShoppingCartList } from "../../../actions/shoppingCartAction";
import { getHistoryShipping } from "../../../actions/postalCodeAction";
import { getUserVoucher } from "../../../actions/kickPointAction";

import {
  doPostPayments,
  doPostApplyVoucher,
  doPostXenditPayment,
  doPostKredivoPayment,
  doPostMidtransPayment,
  doPostAkulakuPayment,
  doGetVoucherCode,
  doFetchProductAddon,
  doPostAtomePayment,
  doPostKredivoAvailableInstallments,
  doPostAkulakuAvailableInstallments,
  doPostSprintasiaPayment
} from "../../../actions/paymentAction";

import {
  doFetchCountries,
  doFetchProvinces,
  doFetchCities,
  doPostShippingCost,
} from "../../../actions/postalCodeAction";

import {
  getOtp,
  resetOtpState,
  getOtpStatus
} from "../../../actions/authAction";

/* IMPORT COMPONENT */
import {
  ModalOutOfStock,
  ModalAlert,
  ModalAddressBookV3,
  ModalVoucherCode,
  ModalOtp
} from "../../Modals";
import ChoosePayments from "../Components/ChoosePayments"
import ModalSnapPay from "../../Modals/ModalSnapPay";
import { ShippingNReturnPolicy } from "../../Modals/StaticInfoModal/ModalStaticInfo";
import PopUpErrorMessage from "./PopUpErrorMessage"
import LeftBagSection from "./LeftBagSection"
import RightBagSectionSummary from "./RightBagSectionSummary"
import ChoosePaymentProcess from "./ChoosePaymentProcess"
import KickCreditProcess from "./KickCreditConfirmationProcess"
import OtherPaymentsConfirmationProcess from "./OtherPaymentsConfirmationProcess"
import AtomeConfirmationProcess from "./AtomeConfirmationProcess"
import KredivoConfirmationProcess from "./KredivoConfirmationProcess"
import AkulakuConfirmationProcess from "./AkulakuConfirmationProcess"
import ChoosePaymentProcessResponsive from "./ChoosePaymentProcessResponsive"

/* IMPORT PAYMENT METHOD */
import {
  BANKTRANSFER,
  VIRTUALACCOUNT,
  CREDITCARD,
  KREDIVO,
  AKULAKU,
  getAdmFees,
  FULLWALLET,
  BCA_VA,
  BRI_VA,
  BNI_VA,
  PERMATA_VA,
  MANDIRI_VA,
  BCA_INSTALLMENTS,
  BCA_CREDIT_CARD,
  DEFAULT_CREDIT_CARD,
  MANDIRI_CREDIT_CARD,
  MANDIRI_DEBIT_CARD,
  BNI_CREDIT_CARD,
  BNI_DEBIT_CARD,
  GOPAY,
  ATOME,
  DEFAULT_PAYMENT_METHOD,
} from "../../../constants/paymentMethods";

/* IMPORT ASSETS */
import CloseButton from "../../../images/bag-delete.png";
import PlusButton from "../../../images/bag-plus.png";
import MinusButton from "../../../images/minus.png";
import PinAddress from "../../../images/pin-address.png";
import ContinueArrow from "../../../images/shopping-cart-continue.png";
import BackArrow from "../../../images/shopping-cart-back.png";
import ArrowsNext from "../../../images/arrowsNext.png";
import CircleBack from "../../../images/circle-back.png";
import WarningSign from "../../../images/warning-orange.png";
import KickAveGif from "../../../images/KickAve.gif";
import SplitPaymentMethodCard from "./KickCreditConfirmationProcess/InitialProcess/SplitPaymentMethodsCard";
import KickAveLogoGif from "../../../images/logokickave_loop.gif";

const DEFAULT_INSTALLMENT_TYPE = "30_days";
const VOUCHER_APPLIED_MSG = "Voucher berhasil diterapkan.";
const OUT_OF_STOCK_MSG = "Sorry, someone else bought this product!";
const PRICE_CHANGED_MSG =
  "This product's price has changed! Please check the new price before checking out.";
const ASKING_PRICE_UP = "PRICE_UP";
const ASKING_PRICE_DOWN = "PRICE_DOWN";
const EVENT_VOUCHER = ["MANDIRIDEBITCB20"];

const LoadingSubmit = ({ show }) => {
  return (
    <ModalReactstrap id="loading-submit-payment-container" isOpen={show}>
      <div className="loading-submit-payment-inner-wrapper">
        <div className="logo-container">
          <KickImage src={KickAveLogoGif} alt="..." />
        </div>
        <div className="text-container">
          <p>Hold On Tight</p>
          <p>We are processing your payment</p>
        </div>
      </div>
    </ModalReactstrap>
  )
}

const CheckoutPageDekstopView = (props) => {
  const {
    currentPaymentMethod,
    _snapPay,
    propsHistory,
    isOpenOutOfStockModal,
    product,
    isErrorModalOpen,
    popUpErrorMessage,
    checkoutProcess,
    addOnSelected,
    productImage,
    category,
    display_name,
    size,
    productCondition,
    etaText,
    asking_price,
    filteredAddOnProduct,
    _umbreEnabled,
    _handleAdditionalChange,
    _getLayananPrice,
    _shippingFee,
    selectedVoucherCode,
    _discount,
    _sell,
    totalAddOnProduct,
    _getTotal,
    selectedAddress,
    isAddressBookOpen,
    shippingHistory,
    countries,
    cities,
    provinces,
    shippingId,
    errMessages,
    changeId,
    submitShipping,
    backToDetailsPage,
    getHistoryShipping,
    setOpenVoucherModal,
    handleClearVoucher,
    _handleSelectedAddress,
    handleModalAddressToggle,
    handleSelectedVoucherCode,
    setIsErrorModalOpen,
    setCheckoutProcess,
    setAmountToBePaid,
    handleFetchKredivoInstallments,
    handleSetAtomePrice,
    defaultId,
    isAddressButtonDisable,
    dataVoucher,
    openVoucherModal,
    amountToBePaid,
    balance,
    dataAkulaku,
    totalBalance,
    isIndonesian,
    balanceUsage,
    creditDebitOnly,
    balance_with_fee,
    availableMethods,
    _installmentsList,
    setIsSplitPayment,
    setCurrentPaymentMethod,
    atomePrice,
    isSplitPayment,
    locked_balance,
    kickCreditProcess,
    isKickPointActive,
    isOpenModalBalanceInfo,
    selectedSplitPaymentMethod,
    selectedSplitKredivoInstallment,
    handleSubmit,
    handleUsageBalance,
    setIsKickPointActive,
    setKickCreditProcess,
    setIsModalBalanceInfo,
    setSelectedSplitPaymentMethod,
    setSelectedSplitKredivoInstallment,
    isSubmit,
    selectedKredivoInstallment,
    setSelectedKredivoInstallment,
    set_SnapPay,
    isLoadingSubmit,
    setIsLoadingSubmit,
    isKickCreditActive,
    setIsKickCreditActive,
    userCurrency,
    isCashback,
    isFetchCourier,
    buyNowPrice,
    isUseVoucher,
    voucher_applicable,
    voucherEnabledPayments
  } = props.propertyForCheckoutPage;
  const isOnlyKickPoint = product?.variant_payment_methods?.length === 1 && !!product?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point");
  const newUserCurrency = isOnlyKickPoint? {
    ...userCurrency,
    currency: "KP"
  } : userCurrency;
  const isVoucherApplicable = isOnlyKickPoint? false : voucher_applicable;

  return (
    <Container fluid id="checkout-page-first-wrapper-dekstop-view">
      <ModalSnapPay
        autoOpenSnapModal
        isCloseable={currentPaymentMethod.payment_method === CREDITCARD}
        isOpen={_snapPay.isOpen}
        invoiceNumber={_snapPay.invoiceNumber}
        trxToken={_snapPay.trxToken}
        redirectUrl={_snapPay.snapUrl}
        expiredAt={_snapPay.expiredAt}
        onToggle={() => {
          set_SnapPay({ ..._snapPay, isOpen: !_snapPay.isOpen })
          window.gtag_report_conversion(`/invoices/${_snapPay.invoiceNumber}?trx_id=${_snapPay.trxToken}`, _snapPay.invoiceNumber)
          propsHistory.replace(_snapPay.redirectUrl);
        }}
        paymentMethodReq={currentPaymentMethod.payment_method}
      />

      {isLoadingSubmit ? <LoadingSubmit show={isLoadingSubmit} /> : null}

      <ModalOutOfStock
        isCloseable
        isOpen={isOpenOutOfStockModal}
        onToggle={() => setIsOpenOutOfStockModal(!isOpenOutOfStockModal)}
        message={OUT_OF_STOCK_MSG}
        buttonPrimaryText={"CHECK AVAILABLE SIZES"}
        onButtonPrimaryClick={() => {
          const { id, slug } = product;
          window.location.reload();
        }}
      />

      <PopUpErrorMessage isErrorModalOpen={isErrorModalOpen} errMessages={popUpErrorMessage} />

      <Row className="shopping-cart-page-second-wrapper">
        <LeftBagSection
          checkoutProcess={checkoutProcess}
          addOnSelected={addOnSelected}
          productImage={productImage}
          category={category}
          display_name={display_name}
          size={size}
          productCondition={productCondition}
          etaText={etaText}
          asking_price={asking_price}
          filteredAddOnProduct={filteredAddOnProduct}
          _umbreEnabled={_umbreEnabled}
          _handleAdditionalChange={_handleAdditionalChange}
          getLayananPrice={convertToRupiah(_getLayananPrice())}
          _getLayananPrice={_getLayananPrice}
          shippingFee={convertToRupiah(_shippingFee)}
          _shippingFee={_shippingFee}
          discount={selectedVoucherCode ? convertToRupiah(_discount) : 0}
          subsidy_price={convertToRupiah(_sell.subsidy_price)}
          totalAddOnProduct={convertToRupiah(totalAddOnProduct)}
          totalPrice={convertToRupiah(_getTotal())}
          selectedVoucherCode={selectedVoucherCode}
          _discount={_discount}
          _sell={_sell}
          _totalAddOnProduct={totalAddOnProduct}
          userCurrency={newUserCurrency}
          isCashback={isCashback}
          buyNowPrice={buyNowPrice}
        />

        {/* SUMMARY AND PAYMENT PROCESS */}
        {checkoutProcess === "" && (
          <RightBagSectionSummary
            selectedAddress={selectedAddress}
            isAddressBookOpen={isAddressBookOpen}
            shippingHistory={shippingHistory}
            countries={countries}
            cities={cities}
            provinces={provinces}
            shippingId={shippingId}
            defaultId={defaultId}
            isAddressButtonDisable={isAddressButtonDisable}
            dataVoucher={dataVoucher}
            selectedVoucherCode={selectedVoucherCode}
            openVoucherModal={openVoucherModal}
            _discount={_discount}
            asking_price={asking_price}
            _sell={_sell}
            _shippingFee={_shippingFee}
            totalAddOnProduct={totalAddOnProduct}
            errMessages={errMessages}
            total={_getTotal()}
            changeId={changeId}
            _getTotal={() => _getTotal()}
            submitShipping={submitShipping}
            _getLayananPrice={_getLayananPrice}
            backToDetailsPage={backToDetailsPage}
            getHistoryShipping={getHistoryShipping}
            setOpenVoucherModal={setOpenVoucherModal}
            handleClearVoucher={handleClearVoucher}
            _handleSelectedAddress={_handleSelectedAddress}
            handleModalAddressToggle={handleModalAddressToggle}
            handleSelectedVoucherCode={handleSelectedVoucherCode}
            setIsErrorModalOpen={setIsErrorModalOpen}
            setCheckoutProcess={setCheckoutProcess}
            setAmountToBePaid={setAmountToBePaid}
            handleFetchKredivoInstallments={handleFetchKredivoInstallments}
            handleSetAtomePrice={handleSetAtomePrice}
            userCurrency={newUserCurrency}
            isCashback={isCashback}
            isFetchCourier={isFetchCourier}
            voucher_applicable={isVoucherApplicable}
          />
        )}

        {/* PAYMENT LIST */}
        {checkoutProcess === "choose-payment" &&
          <ChoosePayments
            setCheckoutProcess={setCheckoutProcess}
            amountToBePaid={amountToBePaid}
            balance={balance}
            dataAkulaku={dataAkulaku}
            totalBalance={totalBalance}
            shippingCountry={selectedAddress?.country || 'IDN'}
            isIndonesian={isIndonesian}
            balanceUsage={balanceUsage}
            creditDebitOnly={creditDebitOnly}
            balance_with_fee={balance_with_fee}
            availableMethods={availableMethods}
            _installmentsList={_installmentsList}
            setIsSplitPayment={setIsSplitPayment}
            handleSetAtomePrice={handleSetAtomePrice}
            setCurrentPaymentMethod={setCurrentPaymentMethod}
            handleFetchKredivoInstallments={handleFetchKredivoInstallments}
            atomePrice={convertToRupiah(atomePrice)}
            locked_balance={locked_balance}
            userCurrency={userCurrency}
            voucherEnabledPayments={voucherEnabledPayments}
          />
        }

        {/* Kick Credit Confirmation */}
        {checkoutProcess === "confirm-kick-credit" && (
          <KickCreditProcess
            balance={balance}
            dataAkulaku={dataAkulaku}
            isIndonesian={isIndonesian}
            balanceUsage={balanceUsage}
            isSplitPayment={isSplitPayment}
            amountToBePaid={amountToBePaid}
            locked_balance={locked_balance}
            availableMethods={availableMethods}
            balance_with_fee={balance_with_fee}
            _installmentsList={_installmentsList}
            kickCreditProcess={kickCreditProcess}
            isKickPointActive={isKickPointActive}
            currentPaymentMethod={currentPaymentMethod}
            isOpenModalBalanceInfo={isOpenModalBalanceInfo}
            selectedSplitPaymentMethod={selectedSplitPaymentMethod}
            selectedSplitKredivoInstallment={selectedSplitKredivoInstallment}
            handleSubmit={handleSubmit}
            setCheckoutProcess={setCheckoutProcess}
            handleUsageBalance={handleUsageBalance}
            setIsKickPointActive={setIsKickPointActive}
            setKickCreditProcess={setKickCreditProcess}
            setIsModalBalanceInfo={setIsModalBalanceInfo}
            setCurrentPaymentMethod={setCurrentPaymentMethod}
            setSelectedSplitPaymentMethod={setSelectedSplitPaymentMethod}
            handleFetchKredivoInstallments={handleFetchKredivoInstallments}
            setSelectedSplitKredivoInstallment={setSelectedSplitKredivoInstallment}
            isSubmit={isSubmit}
            handleSetAtomePrice={handleSetAtomePrice}
            atomePrice={convertToRupiah(atomePrice)}
            isKickCreditActive={isKickCreditActive}
            setIsKickCreditActive={setIsKickCreditActive}
            userCurrency={userCurrency}
            isUseVoucher={isUseVoucher}
            variantPaymentMethods={product?.variant_payment_methods}
          />
        )}

        {/* Virtual Account, Credit Card, Bank Transfer, AkuLaku */}
        {checkoutProcess === "confirm-others-kick-credit" && (
          <OtherPaymentsConfirmationProcess
            amountToBePaid={convertToRupiah(amountToBePaid)}
            currentPaymentMethod={currentPaymentMethod}
            handleSubmit={handleSubmit}
            setCheckoutProcess={setCheckoutProcess}
            setCurrentPaymentMethod={setCurrentPaymentMethod}
            isSubmit={isSubmit}
            userCurrency={newUserCurrency}
          />
        )}

        {/* Atome Process */}
        {checkoutProcess === "confirm-atome-payment" && (
          <AtomeConfirmationProcess
            amountToBePaid={convertToRupiah(amountToBePaid)}
            atomePrice={convertToRupiah(atomePrice)}
            currentPaymentMethod={currentPaymentMethod}
            handleSubmit={handleSubmit}
            setCheckoutProcess={setCheckoutProcess}
            setCurrentPaymentMethod={setCurrentPaymentMethod}
            isSubmit={isSubmit}
          />
        )}

        {/* Kredivo Process */}
        {checkoutProcess === "confirm-kredivo-payment" && (
          <KredivoConfirmationProcess
            amountToBePaid={convertToRupiah(amountToBePaid)}
            _installmentsList={_installmentsList}
            currentPaymentMethod={currentPaymentMethod}
            selectedKredivoInstallment={selectedKredivoInstallment}
            handleSubmit={handleSubmit}
            setCheckoutProcess={setCheckoutProcess}
            setCurrentPaymentMethod={setCurrentPaymentMethod}
            setSelectedKredivoInstallment={setSelectedKredivoInstallment}
            isSubmit={isSubmit}
          />
        )}

        {/* Kredivo Process */}
        {checkoutProcess === "confirm-akulaku-payment" && (
          <AkulakuConfirmationProcess
            amountToBePaid={convertToRupiah(amountToBePaid)}
            _installmentsList={_installmentsList}
            currentPaymentMethod={currentPaymentMethod}
            selectedKredivoInstallment={selectedKredivoInstallment}
            handleSubmit={handleSubmit}
            setCheckoutProcess={setCheckoutProcess}
            setCurrentPaymentMethod={setCurrentPaymentMethod}
            setSelectedKredivoInstallment={setSelectedKredivoInstallment}
            isSubmit={isSubmit}
            dataAkulaku={dataAkulaku}
          />
        )}
      </Row>
    </Container>
  );
};

const CheckoutPageResponsiveView = (props) => {
  const {
    currentPaymentMethod,
    _snapPay,
    propsHistory,
    isOpenOutOfStockModal,
    product,
    isErrorModalOpen,
    popUpErrorMessage,
    checkoutProcess,
    addOnSelected,
    productImage,
    category,
    display_name,
    size,
    productCondition,
    etaText,
    asking_price,
    filteredAddOnProduct,
    _umbreEnabled,
    _handleAdditionalChange,
    _getLayananPrice,
    _shippingFee,
    selectedVoucherCode,
    _discount,
    _sell,
    totalAddOnProduct,
    _getTotal,
    selectedAddress,
    isAddressBookOpen,
    shippingHistory,
    countries,
    cities,
    provinces,
    shippingId,
    errMessages,
    changeId,
    submitShipping,
    backToDetailsPage,
    getHistoryShipping,
    setOpenVoucherModal,
    handleClearVoucher,
    _handleSelectedAddress,
    handleModalAddressToggle,
    handleSelectedVoucherCode,
    setIsErrorModalOpen,
    setCheckoutProcess,
    setAmountToBePaid,
    handleFetchKredivoInstallments,
    handleSetAtomePrice,
    defaultId,
    isAddressButtonDisable,
    dataVoucher,
    openVoucherModal,
    amountToBePaid,
    balance,
    dataAkulaku,
    totalBalance,
    isIndonesian,
    balanceUsage,
    creditDebitOnly,
    balance_with_fee,
    availableMethods,
    _installmentsList,
    setIsSplitPayment,
    setCurrentPaymentMethod,
    atomePrice,
    isSplitPayment,
    locked_balance,
    kickCreditProcess,
    isKickPointActive,
    isOpenModalBalanceInfo,
    selectedSplitPaymentMethod,
    selectedSplitKredivoInstallment,
    handleSubmit,
    handleUsageBalance,
    setIsKickPointActive,
    setKickCreditProcess,
    setIsModalBalanceInfo,
    setSelectedSplitPaymentMethod,
    setSelectedSplitKredivoInstallment,
    isSubmit,
    selectedKredivoInstallment,
    setSelectedKredivoInstallment,
    set_SnapPay,
    isLoadingSubmit,
    isKickCreditActive,
    setIsKickCreditActive,
    userCurrency: newUserCurrency,
    isCashback,
    buyNowPrice,
    isUseVoucher,
    voucher_applicable,
    voucherEnabledPayments
  } = props.propertyForCheckoutPage;
  const lengthAddonProduct = filteredAddOnProduct.filter((item) => {
    if (
      item.active &&
      (item.visible === "*" ||
        item.visible.includes(category)) &&
      !item.isSelected
    )
      return item;
  })
  const isOnlyKickPoint = product?.variant_payment_methods?.length === 1 && !!product?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point");
  const userCurrency = isOnlyKickPoint? {
    ...newUserCurrency,
    currency: "KP"
  } : newUserCurrency;
  const isVoucherApplicable = isOnlyKickPoint? false : voucher_applicable;

  const summaryRef = useRef()

  const [_selectedAddress, set_selectedAddress] = useState(selectedAddress)
  const [isShowDesc, setIsShowDesc] = useState(null)
  const [isShowDescOnSelectedAddOn, setIsShowDescOnSelectedAddOn] = useState(null)
  const [defaultAddressTemp, setDefaultTempAddress] = useState(null)

  const handleShowDescription = (args) => {
    if (args === isShowDesc) {
      setIsShowDesc(null)
    } else {
      setIsShowDesc(args)
    }
  }

  const handleShowDescriptionOnSelectedAddon = (args) => {
    if (args === isShowDescOnSelectedAddOn) {
      setIsShowDescOnSelectedAddOn(null)
    } else {
      setIsShowDescOnSelectedAddOn(args)
    }
  }

  useEffect(() => {
    set_selectedAddress(selectedAddress)
  }, [selectedAddress])

  return (
    <Container fluid id="checkout-page-responsive-view-container">
      <ModalSnapPay
        autoOpenSnapModal
        isCloseable={currentPaymentMethod.payment_method === CREDITCARD}
        isOpen={_snapPay.isOpen}
        invoiceNumber={_snapPay.invoiceNumber}
        trxToken={_snapPay.trxToken}
        redirectUrl={_snapPay.snapUrl}
        expiredAt={_snapPay.expiredAt}
        onToggle={() => {
          // setCheckoutProcess("waiting-payment")
          set_SnapPay({ ..._snapPay, isOpen: !_snapPay.isOpen })
          propsHistory.replace(_snapPay.redirectUrl);
        }}
        paymentMethodReq={currentPaymentMethod.payment_method}
      />

      <PopUpErrorMessage isErrorModalOpen={isErrorModalOpen} errMessages={popUpErrorMessage} />

      {isSubmit ? <LoadingSubmit show={isLoadingSubmit} /> : null}

      {checkoutProcess === "" && (
        <div className="responsive-checkout-second-wrapper">
          {/* BACK BUTTON */}
          <div className="responsive-top-bag-title">
            <KickImage src={CircleBack} alt="..."
              onClick={() => backToDetailsPage()}
            />
            <p>Checkout (Buy Now)</p>
          </div>

          {/* ADDRESS SECTION */}
          <div className="address-section-wrapper">
            <div className="address-section-container"
              onClick={() => handleModalAddressToggle()}
            >
              <div className="image-container">
                <KickImage src={PinAddress} alt="..." />
              </div>
              <div className="description-container">
                <p>Deliver to</p>
                {_selectedAddress?.isAddressNotNull ? (
                  <>
                    <p>
                      {selectedAddress.alias} - {selectedAddress.full_name}
                    </p>
                    <p>
                      {selectedAddress.street_address}, {selectedAddress.city},{" "}
                      {selectedAddress.province}, {selectedAddress.postal_code}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      You haven't add any address yet.
                    </p>
                    <p>
                      Add your shipping address to continue.
                    </p>
                  </>
                )}
              </div>
            </div>
            {isAddressBookOpen && (
              <ModalAddressBookV3
                isOpen={isAddressBookOpen}
                onToggle={() => handleModalAddressToggle()}
                dataAddress={shippingHistory.data || []}
                countries={countries.data || []}
                provinces={provinces.data || []}
                cities={cities.data || []}
                id={shippingId ? shippingId : selectedAddress.id}
                changeId={changeId}
                defaultId={defaultId}
                submitShipping={submitShipping}
                getHistoryShipping={getHistoryShipping}
                handleSelectedAddress={_handleSelectedAddress}
                isModalOffer={true}
                isAddressButtonDisable={isAddressButtonDisable}
                setDefaultTempAddress={setDefaultTempAddress}
                defaultAddressTemp={defaultAddressTemp}
              />
            )}
          </div>

          {/* VOUCHER SECTION */}
          <div className="voucher-section-container">
            <div className={`voucher-section-section-wrapper ${isVoucherApplicable ? "" : "voucher-disabled"}`}>
              <div className="voucher-title">
                <p>Have a voucher code?</p>
              </div>
              {
                isVoucherApplicable ?
                  <div className="voucher-content">
                    <div className="voucher-text">
                      {
                        selectedVoucherCode ? <p>{selectedVoucherCode.code}</p> :
                          <p>{dataVoucher?.data?.length > 0 ? "You have vouchers available" : "Enter voucher code here"}</p>
                      }
                    </div>
                    <div className="voucher-button"
                      onClick={() => setOpenVoucherModal(!openVoucherModal)}
                    >
                      <p>View</p>
                    </div>
                  </div>
                  :
                  <div className="voucher-content-disabled">
                    <p>Cannot use voucher on this product</p>
                  </div>
              }
              <ModalVoucherCode
                isOpen={openVoucherModal}
                onToggle={() => setOpenVoucherModal(!openVoucherModal)}
                selectedVoucherCode={selectedVoucherCode}
                handleSelectedVoucherCode={handleSelectedVoucherCode}
                _handleClearVoucher={handleClearVoucher}
                discount={_discount}
              />
            </div>
          </div>

          {/* PRODUCT CARD + ADDON SELECTED */}
          <div className="responsive-checkout-product-container">
            {/* MAIN PRODUCT ITEM */}
            <div className="checkout-item-card">
              <div className="main-item-image-wrapper">
                {productImage ? (
                  <KickImage
                    src={getCloudImageUrl(productImage, 500)}
                    alt="..."
                  />
                ) : (
                  <KickImage src={emptyImage(category)} alt="..." />
                )}
              </div>
              <div className="main-item-description-wrapper">
                <div className="name-n-condition">
                  <p>{display_name}</p>
                  <p>
                    {size.US} / {productCondition} / {etaText}{" "}
                  </p>
                </div>
                <div className="price-wrapper">
                  <p>{formatCurrency(parseInt(buyNowPrice), userCurrency.ratio, userCurrency.currency)}</p>
                  {/* <p>Qty: 1</p> */}
                </div>
              </div>
            </div>

            {/* ADD ONS ITEM */}
            {filteredAddOnProduct.length > 0 &&
              filteredAddOnProduct
                .filter((item) => item.isSelected)
                .map((item, index) => {
                  const { img_url, displayName, description, price } = item
                  const removeBrDescription = (() => {
                    const splitted = description ? description.split("<br>") : [];
                    return splitted[1] ? `${splitted[0]}${splitted[1]}` : description
                  })();
                  return (
                    <div className="addon-item-wrapper">
                      <div className="remove-addon">
                        <KickImage src={CloseButton} alt="..."
                          onClick={() => {
                            _handleAdditionalChange(item, !item.isSelected);
                          }}
                        />
                      </div>
                      <div className="addon-item-card-image-wrapper">
                        {img_url ? <KickImage src={img_url} alt="..." /> : null}
                      </div>
                      <div className="addon-description-wrapper">
                        <div className="name-n-condition" onClick={() => handleShowDescriptionOnSelectedAddon(index)}>
                          <p>{displayName}</p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: removeBrDescription,
                            }}
                            className={`description-text ${removeBrDescription ? "" : "remove-after"} ${isShowDescOnSelectedAddOn === index ? "show" : ""}`}
                          />
                        </div>
                        <div className="price-container">
                          <p>{formatCurrency(parseInt(price), userCurrency.ratio, userCurrency.currency)}</p>
                          {/* <p>Qty: 1</p> */}
                        </div>
                      </div>
                    </div>
                  )
                })}
          </div>

          {/* ADDON LIST */}
          {filteredAddOnProduct
            .filter((item) => {
              if (
                item.active &&
                (item.visible === "*" ||
                  item.visible.includes(category)) &&
                !item.isSelected
              )
                return item;
            }).length !== 0 &&
            <div className="addon-list-container">
              <div className="extra-item-title-wrapper">
                <h3 className="extra-item-title">
                  Extra love for your purchase
                </h3>
              </div>
              <div className="addon-list-scroll-wrapper">
                {filteredAddOnProduct
                  .filter((item) => {
                    if (
                      item.active &&
                      (item.visible === "*" ||
                        item.visible.includes(category)) &&
                      !item.isSelected
                    )
                      return item;
                  })
                  .map((item, index) => {
                    const { img_url, displayName, description, price } = item || {};
                    let disable =
                      item.name &&
                      item.name.toUpperCase() === "KAXUMBRE" &&
                      !_umbreEnabled;
                    const removeBrDescription = (() => {
                      const splitted = description ? description.split('<br>') : [];
                      return splitted[1] ? `${splitted[0]}${splitted[1]}` : description
                    })();
                    return (
                      <div className="extra-item-card">
                        <div className="extra-item-image-wrapper">
                          {img_url ? <KickImage src={img_url} alt="..." /> : null}
                        </div>
                        <div className="extra-item-description">
                          <div className="name-and-description" onClick={() => handleShowDescription(index)}>
                            <p>{displayName}</p>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: removeBrDescription,
                              }}
                              className={`description-text ${removeBrDescription ? "" : "remove-after"} ${isShowDesc === index ? "show" : ""}`}
                            />
                          </div>
                          <div className="selected-addon-price-container">
                            <p>
                              {formatCurrency(parseInt(price), userCurrency.ratio, userCurrency.currency)}
                            </p>
                            <KickImage
                              onClick={() => {
                                !disable ?
                                  _handleAdditionalChange(
                                    item,
                                    !item.isSelected
                                  ) : null
                              }}
                              className="extra-item-add-button-icon"
                              src={PlusButton}
                              alt="..."
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          }
          {/* PAYMENT SUMMARY */}
          <div ref={summaryRef} className="payment-summary-container">
            <div className="summary-description-wrapper">
              <div className="title summary-row">
                <p>Payment Summary</p>
              </div>
              <div className="product-price summary-row">
                <p>Product Price</p>
                <p>{formatCurrency(parseInt(asking_price), userCurrency.ratio, userCurrency.currency)}</p>
              </div>
              {_getLayananPrice() > 0 && <div className="adm-fee summary-row">
                <p>Administration Fee</p>
                <p>{formatCurrency(_getLayananPrice(), userCurrency.ratio, userCurrency.currency)}</p>
              </div>}
              {_shippingFee > 0 && <div className="shipping-fee summary-row">
                <p>Shipping &#38; Handling</p>
                <p>{formatCurrency(_shippingFee, userCurrency.ratio, userCurrency.currency)}</p>
              </div>}
              {selectedVoucherCode && _discount > 0 &&
                <div className="discount summary-row">
                  <p>{isCashback ? "Potential Cashback" : "Voucher Code"}</p>
                  <p className="cashback">
                    {_discount ? isCashback ? "" : "-" : ""}
                    {formatCurrency(_discount, userCurrency.ratio, userCurrency.currency)}
                  </p>
                </div>
              }
              {
                _sell.subsidy_price > 0 && <div className="subsidy-price summary-row">
                  <p>
                    Discount &#40;<span>Automatically applied</span>&#41;
                  </p>
                  <p>{formatCurrency(_sell.subsidy_price, userCurrency.ratio, userCurrency.currency)}</p>
                </div>
              }
              {totalAddOnProduct > 0 && <div className="promo-product summary-row">
                <p>Promo Product</p>
                <p>{formatCurrency(totalAddOnProduct, userCurrency.ratio, userCurrency.currency)}</p>
              </div>}
            </div>
          </div>

          {/* CONTINUE BUTTON */}
          {!isAddressBookOpen && !openVoucherModal && <div className="floating-continue-button-container">
            <div onClick={() => summaryRef.current.scrollIntoView({ behavior: "smooth" })} className="total-price">
              <p>Total</p>
              <p>{formatCurrency(_getTotal(), userCurrency.ratio, userCurrency.currency)}</p>
            </div>
            <div className="right-bag-content-summary-button"
              onClick={() => {
                if (errMessages.length > 0) {
                  setIsErrorModalOpen(true);
                } else {
                  setCheckoutProcess("choose-payment");
                  setAmountToBePaid(_getTotal());
                  handleFetchKredivoInstallments();
                  handleSetAtomePrice();
                }
              }}
            >
              <p>Choose Payment</p>
              <KickImage src={ContinueArrow} alt="..." />
            </div>
          </div>}
        </div>
      )
      }

      {/* PAYMENT LIST */}
      {checkoutProcess === "choose-payment" &&
        <ChoosePayments
          isResponsive={true}
          setCheckoutProcess={setCheckoutProcess}
          amountToBePaid={amountToBePaid}
          total={_getTotal()}
          balance={balance}
          dataAkulaku={dataAkulaku}
          totalBalance={totalBalance}
          isIndonesian={isIndonesian}
          shippingCountry={selectedAddress?.country || 'IDN'}
          balanceUsage={balanceUsage}
          creditDebitOnly={creditDebitOnly}
          balance_with_fee={balance_with_fee}
          availableMethods={availableMethods}
          _installmentsList={_installmentsList}
          setIsSplitPayment={setIsSplitPayment}
          setCheckoutProcess={setCheckoutProcess}
          handleSetAtomePrice={handleSetAtomePrice}
          setCurrentPaymentMethod={setCurrentPaymentMethod}
          handleFetchKredivoInstallments={handleFetchKredivoInstallments}
          filteredAddOnProduct={filteredAddOnProduct}
          productImage={productImage}
          category={category}
          display_name={display_name}
          productCondition={productCondition}
          etaText={etaText}
          size={size}
          asking_price={asking_price}
          _handleAdditionalChange={_handleAdditionalChange}
          emptyImage={emptyImage(category)}
          _umbreEnabled={_umbreEnabled}
          _getLayananPrice={_getLayananPrice()}
          shipping_fee={_shippingFee}
          selectedVoucherCode={selectedVoucherCode}
          _sell={_sell}
          totalAddOnProduct={totalAddOnProduct}
          locked_balance={locked_balance}
          userCurrency={userCurrency}
          discount={_discount}
          isCashback={isCashback}
          buyNowPrice={buyNowPrice}
          subsidy_price={_sell.subsidy_price}
          voucherEnabledPayments={voucherEnabledPayments}
        />
      }

      {/* Kick Credit Confirmation */}
      {checkoutProcess === "confirm-kick-credit" && (
        <KickCreditProcess
          balance={balance}
          dataAkulaku={dataAkulaku}
          isIndonesian={isIndonesian}
          balanceUsage={balanceUsage}
          isSplitPayment={isSplitPayment}
          amountToBePaid={amountToBePaid}
          locked_balance={locked_balance}
          availableMethods={availableMethods}
          balance_with_fee={balance_with_fee}
          _installmentsList={_installmentsList}
          kickCreditProcess={kickCreditProcess}
          isKickPointActive={isKickPointActive}
          currentPaymentMethod={currentPaymentMethod}
          isOpenModalBalanceInfo={isOpenModalBalanceInfo}
          selectedSplitPaymentMethod={selectedSplitPaymentMethod}
          selectedSplitKredivoInstallment={selectedSplitKredivoInstallment}
          handleSubmit={handleSubmit}
          setCheckoutProcess={setCheckoutProcess}
          handleUsageBalance={handleUsageBalance}
          setIsKickPointActive={setIsKickPointActive}
          setKickCreditProcess={setKickCreditProcess}
          setIsModalBalanceInfo={setIsModalBalanceInfo}
          setCurrentPaymentMethod={setCurrentPaymentMethod}
          setSelectedSplitPaymentMethod={setSelectedSplitPaymentMethod}
          handleFetchKredivoInstallments={handleFetchKredivoInstallments}
          setSelectedSplitKredivoInstallment={setSelectedSplitKredivoInstallment}
          isSubmit={isSubmit}
          handleSetAtomePrice={handleSetAtomePrice}
          atomePrice={convertToRupiah(atomePrice)}
          isKickCreditActive={isKickCreditActive}
          setIsKickCreditActive={setIsKickCreditActive}
          isResponsive={true}
          isUseVoucher={isUseVoucher}
          userCurrency={userCurrency}
          variantPaymentMethods={product?.variant_payment_methods}
        />
      )}

      {/* Virtual Account, Credit Card, Bank Transfer, AkuLaku */}
      {checkoutProcess === "confirm-others-kick-credit" && (
        <OtherPaymentsConfirmationProcess
          amountToBePaid={convertToRupiah(amountToBePaid)}
          isSubmit={isSubmit}
          currentPaymentMethod={currentPaymentMethod}
          handleSubmit={handleSubmit}
          setCheckoutProcess={setCheckoutProcess}
          setCurrentPaymentMethod={setCurrentPaymentMethod}
          userCurrency={newUserCurrency}
        />
      )}

      {/* Atome Process */}
      {checkoutProcess === "confirm-atome-payment" && (
        <AtomeConfirmationProcess
          amountToBePaid={convertToRupiah(amountToBePaid)}
          isSubmit={isSubmit}
          atomePrice={convertToRupiah(atomePrice)}
          currentPaymentMethod={currentPaymentMethod}
          handleSubmit={handleSubmit}
          setCheckoutProcess={setCheckoutProcess}
          setCurrentPaymentMethod={setCurrentPaymentMethod}
        />
      )}

      {/* Kredivo Process */}
      {checkoutProcess === "confirm-kredivo-payment" && (
        <KredivoConfirmationProcess
          amountToBePaid={convertToRupiah(amountToBePaid)}
          isSubmit={isSubmit}
          _installmentsList={_installmentsList}
          currentPaymentMethod={currentPaymentMethod}
          selectedKredivoInstallment={selectedKredivoInstallment}
          handleSubmit={handleSubmit}
          setCheckoutProcess={setCheckoutProcess}
          setCurrentPaymentMethod={setCurrentPaymentMethod}
          setSelectedKredivoInstallment={setSelectedKredivoInstallment}
        />
      )}

      {/* Akulaku Process */}
      {
        checkoutProcess === "confirm-akulaku-payment" && (
          <AkulakuConfirmationProcess
            amountToBePaid={convertToRupiah(amountToBePaid)}
            _installmentsList={_installmentsList}
            currentPaymentMethod={currentPaymentMethod}
            selectedKredivoInstallment={selectedKredivoInstallment}
            handleSubmit={handleSubmit}
            setCheckoutProcess={setCheckoutProcess}
            setCurrentPaymentMethod={setCurrentPaymentMethod}
            setSelectedKredivoInstallment={setSelectedKredivoInstallment}
            isSubmit={isSubmit}
            dataAkulaku={dataAkulaku}
          />
        )
      }
    </Container>
  )
}

function CheckoutPage(props) {
  if (!props.dataProductInProgress?.isFromDetail) {
    props.history.push("/");
    return <div></div>
  }

  const {
    dataProductInProgress,
    productAddon,
    doFetchProductAddon,
    getHistoryShipping,
    dataPostalCode,
    getCountries,
    getCities,
    dataCountries,
    getProvinces,
    dataProvinces,
    dataAuth,
    dataPayments,
    dataCart,
    getShippingFee,
    getUserVoucher,
    dataVoucher,
    dataAkulaku,
    doGetKredivoInstallments,
    selectedSize,
    doGetAkulakuInstallments,
    userCurrency,
    collection_id,
    userData,
    submitXenditPayment,
    submitMidtransPayment,
    submitKredivoPayment,
    submitAkulakuPayment,
    submitAtomePayment,
    submitPayment,
    submitSprintAsiaPayment,
    getOtp,
    otpCode,
    resetOtpState,
    getOtpStatus,
    otpStatus
  } = props;

  const { shippingHistory } = dataPostalCode;
  const propsHistory = props.history
  const {
    dataInprogress,
    isFromDetail,
    allParentProps,
  } = dataProductInProgress;

  const { category, sell, size, productCondition, etaText, buyNowPrice } =
    dataInprogress || {};

  const {
    asking_price,
    id: user_sell_id
  } = sell || {}

  const { currentURL = {}, thumbnailsProps, product = {} } = allParentProps || {};
  const [width, setWidth] = useState(0);

  /* USE EFFECTS */
  const { saveToLocalStorage, checkIfExpired, resendOtp, resetOtpFromLocalstorage, saveResendOtpToLocalStorage } = useOtpStorage()
  useLayoutEffect(() => {
    const updateSize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", updateSize);
  });

  const fetchAkuLakuInstallmentHandler = () => {
    const { asking_price, id, box_condition, size_id, size } = selectedSize || {};

    const prod = {
      id: product.id,
      user_sell_id: id,
      name: product.display_name,
      price: parseInt(buyNowPrice),
      quantity: 1,
    };

    doGetAkulakuInstallments(prod);
  }

  const [isOtpActive, setIsOtpActive] = useState(false)

  // COMPONENT DID MOUNT
  useEffect(() => {
    if (!dataInprogress || !isFromDetail || !currentURL) {
      props.history.push("/");
    }
    setWidth(window.innerWidth);
    fetchAkuLakuInstallmentHandler();
    doFetchProductAddon();
    getHistoryShipping();
  }, []);

  // GET CITIES, COUNTRIES, PROVINCES
  useEffect(() => {
    const { country, province } = shippingHistory.data
      ? shippingHistory.data.length > 0 ? shippingHistory.data[0]
        : {} : {};

    getCountries();
    getProvinces(country);
    getCities(country, province);
  }, [shippingHistory]);

  const backToDetailsPage = () => {
    props.history.push(`${currentURL.url}`);
    resetOtpState()
  };

  const {
    provinces,
    countries,
    cities,
    couriers,
  } = dataPostalCode;
  const {
    id: initShippingId,
    alias: initAlias,
    full_name: initFullName,
    street_address: initStreetAddress,
    city: initCity,
    province: initProvince,
    postal_code: initPostalCode,
    country: initCountry,
  } = shippingHistory.data ? shippingHistory.data.length > 0 ? shippingHistory.data[0] : {} : {};
  const { display_name } = sell.product_variant;
  const { userdata } = dataAuth;
  const { balance, balance_with_fee, locked_balance } = userdata || {};

  /* USE STATE */
  // GENERAL STATE
  const [errMessages, setErrMessages] = useState([]);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [checkoutProcess, setCheckoutProcess] = useState("");
  const [kickCreditProcess, setKickCreditProcess] = useState("");
  const [_discount, set_Discount] = useState(0);
  const [amountToBePaid, setAmountToBePaid] = useState(0);
  const [popUpErrorMessage, setPopUpErrorMessage] = useState("")
  const [totalBalance, setTotalBalance] = useState(
    +balance + +balance_with_fee + +locked_balance
  );
  const [currentPaymentMethod, setCurrentPaymentMethod] = useState({});
  const [selectedSplitPaymentMethod, setSelectedSplitPaymentMethod] = useState(
    null
  );
  const [isSplitPayment, setIsSplitPayment] = useState(false);
  const [selectedKredivoInstallment, setSelectedKredivoInstallment] = useState(
    null
  );
  const [
    selectedSplitKredivoInstallment,
    setSelectedSplitKredivoInstallment,
  ] = useState(null);
  const [atomePrice, setAtomePrice] = useState(0);
  const [balanceUsage, setBalanceUsage] = useState({
    sellerCredit: 0,
    kickCredit: 0,
    kickPoint: 0,
    remainingPayment: 0,
  });
  const [_shippingFee, set_ShippingFee] = useState(0);
  const [fetchShippingFee, setFetchShippingFee] = useState(true);
  const [_installmentsList, set_InstallmentsList] = useState([]);
  const [_paymentMethods, setPaymentMethods] = useState(DEFAULT_PAYMENT_METHOD);
  const [walletPayment, setWalletPayment] = useState(false);
  const [_kickAmount, set_KickAmount] = useState(0);
  const [_administrationFee, set_AdministrationFee] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [isKickPointActive, setIsKickPointActive] = useState(false);
  const [isKickCreditActive, setIsKickCreditActive] = useState(false);
  const [_modalOutOfStockMsg, set_ModalOutOfStockMsg] = useState(
    OUT_OF_STOCK_MSG
  );
  const [_askingPriceStatus, set_AskingPriceStatus] = useState(null);
  const [_submitPayment, set_SubmitPayment] = useState(false);
  const [_processed, set_Processed] = useState(false);
  const [_shouldRedirect, set__ShouldRedirect] = useState(false);
  const [_isPickGoodDay, set_IsPickGoodDay] = useState(false);
  const [_provinceSelected, set__ProvinceSelected] = useState([]);
  const [_province, set_Province] = useState("");
  const [_isErrorShippingFetch, set_IsErrorShippingFetch] = useState(false);
  const [filteredAddOnProduct, setAddOnProduct] = useState([]);
  const [totalAddOnProduct, setTotalAddOnProduct] = useState(0);
  const [addOnSelected, setAddOnSelected] = useState([]);
  const [_snapPay, set_SnapPay] = useState({
    isOpen: false,
    invoiceNumber: null,
    trxToken: null,
    redirectUrl: "",
    externalUrl: null,
    expiredAt: null,
    _processed: false,
    _shouldRedirect: false,
  });
  const [_sell, set_Sell] = useState({
    ...sell,
    asking_price: parseFloat(sell.asking_price),
    subsidy_price: sell.subsidy_price ? parseInt(sell.subsidy_price) : 0,
  });
  const [_additionalProducts, set_AdditionalProducts] = useState([]);
  const [_umbreEnabled, set_UmbreEnabled] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false)
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)
  const [voucherEnabledPayments, setVoucherEnabledPayment] = useState(null)
  const [isUseVoucher, setIsUseVoucher] = useState(false)
  const [showModalOtp, setShowModalOtp] = useState(false);
  const [gettingOtp, setGettingOtp] = useState(false);
  const [otpErrorMsg, setOtpErrorMsg] = useState("");
  const [currentProcess, setCurrentProcess] = useState("");

  // TOGGLE MODAL STATE
  const [isOpenOutOfStockModal, setIsOpenOutOfStockModal] = useState(false);
  const [openModalAlert, setOpenModalAlert] = useState(false);
  const [isOpenModalBalanceInfo, setIsModalBalanceInfo] = useState(false);

  // SHIPPING STATE
  const [isAddressBookOpen, setIsAddressBookOpen] = useState(false);
  const [isAddressButtonDisable, setIsAddressButtonDisable] = useState(false);
  const [shippingId, setShippingId] = useState(initShippingId || 0);
  const [defaultId, setDefaultId] = useState(initShippingId || 0);
  const [_error, setError] = useState("");
  const [selectedShipping, setSelectedShipping] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState({
    id: initShippingId,
    alias: initAlias,
    full_name: initFullName,
    street_address: initStreetAddress,
    city: initCity,
    province: initProvince,
    postal_code: initPostalCode,
    country: initCountry,
  });

  // VOUCHERS STATE
  const [openVoucherModal, setOpenVoucherModal] = useState(false);
  const [selectedVoucherCode, setSelectedVoucherCode] = useState(null);
  const [creditDebitOnly, setCreditDebitOnly] = useState(false);
  const [_voucherValidated, set_VoucherValidated] = useState(null);
  const [_isValidVoucher, set_IsValidVoucher] = useState(false);
  const [_voucherInput, set_VoucherInput] = useState("");
  const [isCashback, setIsCashback] = useState(false)

  // PAYMENT STATE
  const [paymentType, setPaymentType] = useState(
    userCurrency.currency === "IDR" ? BCA_VA : CREDITCARD
  );

  /* LOCAL METHOD */
  /*-------------SHIPPING METHOD---------------------------------*/
  const changeId = (id) => {
    setIsAddressButtonDisable(true);
    setShippingId(id);
  };

  const _handleSelectedAddress = (item) => {
    getProvinces(item.country);
    getCountries();
    getCities(item.country, item.province);
    setSelectedAddress({ ...item, isAddressNotNull: true });
    setIsAddressButtonDisable(false);
    setError("");
  };

  const handleModalAddressToggle = () => {
    setIsAddressBookOpen(!isAddressBookOpen);
  };

  const submitShipping = () => {
    setDefaultId(shippingId);
    const temp = shippingHistory.data.filter(
      (item) => item.id === shippingId
    )[0];
    _handleSelectedAddress(temp || selectedAddress);
    setSelectedShipping(!temp ? selectedAddress.alias : temp.alias);
    setFetchShippingFee(true)
    setShippingId(!temp ? selectedAddress.id : temp.id);
    setIsAddressBookOpen(!isAddressBookOpen);
  };
  /* -------------------END OF SHIPPING METHOD---------------------- */

  /* ------------------VOUCHERS METHODS------------------------------ */
  const handleSelectedVoucherCode = (data) => {
    if (!data) return;
    const enabledBCA = data && data?.code?.indexOf("KABCALAUNCH") > -1 ? true : false;
    // const isPaymentEnabled = !data?.enabled_payments ? null : DEFAULT_PAYMENT_METHOD.map(method => {
    //   return data?.enabled_payments.includes(method.payment_method) ? method : { ...method, active: false }
    // })
    setIsUseVoucher(true)
    setVoucherEnabledPayment(data.enabled_payments)
    setSelectedVoucherCode(data);
    setCreditDebitOnly(enabledBCA);
    enabledBCA && setPaymentType(DEFAULT_CREDIT_CARD);
  };

  const handleClearVoucher = (e) => {
    e.preventDefault();

    let tempAdminFee = _getAdmFee(
      paymentType,
      _sell.asking_price,
      _shippingFee,
      0
    );

    setIsUseVoucher(false)
    setSelectedVoucherCode(null)
    set_AdministrationFee(tempAdminFee);
    set_VoucherInput("");
    set_VoucherValidated(null);
    set_IsValidVoucher(false);
    set_Discount(0);
    setCreditDebitOnly(false);
    setVoucherEnabledPayment(null);
  };

  const _getVoucherAmount = (voucherObj, price, courierPrice) => {
    let discount = 0;

    if (voucherObj !== null) {
      if (voucherObj.deduct_type === VOUCHER_PRODUCT_TYPE) {
        if (voucherObj.type === "percentage") {
          discount = parseInt(Math.ceil((parseInt(voucherObj.amount) / 100) * price));
        } else {
          discount = voucherObj.amount;
        }
        discount =
          voucherObj.max_amount &&
            parseInt(discount) > parseInt(voucherObj.max_amount)
            ? voucherObj.max_amount
            : discount;
        return discount > price ? price : discount;
      } else if (voucherObj.deduct_type === VOUCHER_COURIER_TYPE) {
        if (voucherObj.type === "percentage") {
          discount = parseInt(
            Math.ceil((voucherObj.amount / 100) * courierPrice)
          );
        } else {
          discount = voucherObj.amount;
        }
        discount =
          voucherObj.max_amount &&
            parseInt(discount) > parseInt(voucherObj.max_amount)
            ? voucherObj.max_amount
            : discount;
        return discount > courierPrice ? courierPrice : discount;
      }
    }
    return discount;
  };

  const _getAdmFee = (paymentType, price, courierPrice, discount) => {
    return getAdmFees(paymentType, price, courierPrice, discount);
  };

  const _redirectBankTransfer = (url, invoice_number) => {
    window.gtag_report_conversion(url, invoice_number)
    propsHistory.replace(`/invoices/${invoice_number}`);
  };

  const _redirectPayment = async (url, invoice_number) => {
    window.gtag_report_conversion(url, invoice_number)
    if (url) {
      window.location.href = url;
    } else {
      propsHistory.replace(`/invoices/${invoice_number}`);
    }
  };

  const _getTotalAddOnProduct = () => {
    return filteredAddOnProduct
      .filter((item) => item.active && item.isSelected)
      .reduce((current, item) => current + item.price, 0);
  };

  const _getLayananPrice = () => {
    return parseFloat(_administrationFee);
  };

  const _getWalletValue = () => {
    return isNaN(parseFloat(_kickAmount)) ? 0 : parseFloat(_kickAmount);
  };

  const _getTotal = () => {
    const { asking_price, subsidy_price, total_price } = _sell;
    const totalPromo = _getTotalAddOnProduct();
    const total = parseFloat(
      asking_price +
      _shippingFee -
      (isCashback ? 0 : _discount) +
      _getLayananPrice() +
      totalPromo -
      _getWalletValue() -
      parseInt(subsidy_price || 0)
    );
    return total;
  };

  const _getTotalWithoutWallet = () => {
    const { asking_price, subsidy_price } = _sell;
    const totalPromo = _getTotalAddOnProduct();
    const total = parseFloat(
      asking_price +
      _shippingFee -
      _discount +
      _getLayananPrice() +
      totalPromo -
      parseInt(subsidy_price || 0)
    );
    return total;
  };

  const _getProvinceId = () => {
    return _provinceSelected || 0;
  };

  const _handleAdditionalChange = async (data, isSelected) => {
    const numberOfSelected = filteredAddOnProduct.filter(
      (item) =>
        item.promoType === "goodday" &&
        item.isSelected &&
        item.name !== data.name
    );
    const userBalance = userdata.balance;
    const isNotEnough = paymentType === FULLWALLET && userBalance < _getTotal();
    const kickAmountTemp = _getTotalWithoutWallet() - 100000;

    //NEW STATE
    const addOnPayload = filteredAddOnProduct.map((item) => {
      if (data.name === item.name) {
        return {
          ...item,
          isSelected: numberOfSelected.length > 1 ? false : isSelected,
        };
      }
      return item;
    });
    const newIsPickGoodDay = numberOfSelected.length > 1;
    const newPaymentType = isNotEnough ? MANDIRI_VA : paymentType;
    const newKickAmount = isNotEnough
      ? `${kickAmountTemp.toString().replace(/^0|[^\d]+/g, "")}.00`
      : 0;
    const newWalletPayment =
      isNotEnough && paymentType === FULLWALLET ? false : walletPayment;
    const newOpenModalAlert = isNotEnough ? true : false;

    const totalAddOn = addOnPayload
      .filter((item) => item.price && item.isSelected)
      .map((item) => item.price)
      .reduce((a, b) => a + b, 0);

    const newAddOnPorduct = addOnPayload.filter((item) => item.id !== data.id);

    const _addOnSelected = addOnPayload.filter((item) => item.isSelected)

    await setAddOnSelected(_addOnSelected); // data addon ini dipakai untuk menampilkan data di product card
    await set_AdditionalProducts(addOnPayload); // data addon ini dipakai untuk checkout
    // setAddOnProduct(newAddOnPorduct);
    await setAddOnProduct(addOnPayload);
    await setTotalAddOnProduct(totalAddOn);
    await set_IsPickGoodDay(newIsPickGoodDay);
    await setPaymentType(newPaymentType);
    await set_KickAmount(newKickAmount);
    await setWalletPayment(newWalletPayment);
    await setOpenModalAlert(newOpenModalAlert);
    _calculateShippingFee(_getProvinceId(), addOnPayload);
  };

  const _calculateShippingFee = async (provinceId, addOnProduct = null) => {
    const { country } = selectedAddress
    const { id, weight } = product || {};
    const addons = addOnProduct
      ? addOnProduct
        .filter((item) => item.isSelected)
        .map((item) => item.name)
        .join(" + ")
      : filteredAddOnProduct
        .filter((item) => item.isSelected)
        .map((item) => item.name)
        .join(" + ");

    let payloads = {
      country,
      destination: provinceId,
      product_variant_id: id,
      weight: weight || 1000,
      courier: "FLAT_RATE",
      product_price: parseInt(buyNowPrice),
    };
    setFetchShippingFee(true)
    // if (addons) payloads = { ...payloads, product_addon: addons };
    await set_IsErrorShippingFetch(false);
    await getShippingFee(payloads).then(() => setFetchShippingFee(false))
  };

  const fetchKredivoInstallments = () => {
    const { kredivoAvailableInstallment } = dataPayments;
    if (kredivoAvailableInstallment.status_code === 200) {
      if (kredivoAvailableInstallment.user_sell_id === _sell.id) {
        const list = kredivoAvailableInstallment.data.installments.map(
          (item) => {
            return {
              value: item.id,
              label: item.name,
              monthly_installment: item.monthly_installment,
            };
          }
        );
        set_InstallmentsList(list);
      }
    } else {
      // Fetch now...
      // Or not show, because have been loaded from product detail page.
    }
  };

  const handleUsageBalance = (walletType, isActive) => {
    // Parse all balance to type integer
    let kickCreditBalance = parseInt(balance);
    let balanceWithFee = parseInt(balance_with_fee);
    let lockedBalance = parseInt(locked_balance);

    const {
      kickCredit,
      kickPoint,
      sellerCredit,
      remainingPayment
    } = balanceUsage

    // Define remaining payment
    let currentRemainingPayment = remainingPayment;

    let temporaryKickPoint = 0

    if (walletType === "kick_points") {
      if (isActive) {
        // HANDLE JIKA REMAINING PAYMENT 0 POINTS TIDAK BISA DI PAKAI
        if (remainingPayment === 0) return
        // Calculate how much of kickpoint used IF ONLY kick points active
        let selisihKickPointsWithTobePaid =
          lockedBalance - currentRemainingPayment;

        temporaryKickPoint =
          selisihKickPointsWithTobePaid <= 0
            ? lockedBalance
            : lockedBalance - selisihKickPointsWithTobePaid;
        currentRemainingPayment =
          selisihKickPointsWithTobePaid <= 0
            ? Math.abs(selisihKickPointsWithTobePaid)
            : 0;

        setBalanceUsage({
          ...balanceUsage,
          kickPoint: temporaryKickPoint,
          remainingPayment: currentRemainingPayment,
        });
      } else {
        const totalBalance = kickCredit + sellerCredit
        const remain = amountToBePaid - currentRemainingPayment - totalBalance
        setBalanceUsage({
          ...balanceUsage,
          kickPoint: 0,
          remainingPayment: currentRemainingPayment + remain,
        });
      }
    } else if (walletType === "kick_credits") {
      if (isActive) {
        // HANDLE JIKA REMAINING PAYMENT 0 CREDIT TIDAK BISA DI PAKAI
        if (remainingPayment === 0) return

        // 1. Calculate usage of sellerCredit first
        let selisihSellerCreditWithTobePaid =
          balanceWithFee - currentRemainingPayment;

        let sellerCredit =
          selisihSellerCreditWithTobePaid <= 0
            ? balanceWithFee
            : balanceWithFee - selisihSellerCreditWithTobePaid;
        currentRemainingPayment =
          selisihSellerCreditWithTobePaid <= 0
            ? Math.abs(selisihSellerCreditWithTobePaid)
            : 0;

        // 2. Second calculate how much of kickCredit used
        let selisihKickCreditWithTobePaid =
          kickCreditBalance - currentRemainingPayment;

        let kickCredit =
          selisihKickCreditWithTobePaid <= 0
            ? kickCreditBalance
            : kickCreditBalance - selisihKickCreditWithTobePaid;
        currentRemainingPayment =
          selisihKickCreditWithTobePaid <= 0
            ? Math.abs(selisihKickCreditWithTobePaid)
            : 0;

        setBalanceUsage({
          ...balanceUsage,
          sellerCredit,
          kickCredit,
          remainingPayment: currentRemainingPayment,
        });
      } else {
        const remain = amountToBePaid - currentRemainingPayment - kickPoint
        setBalanceUsage({
          ...balanceUsage,
          sellerCredit: 0,
          kickCredit: 0,
          remainingPayment: currentRemainingPayment + remain,
        });
      }
    } else {
      setBalanceUsage({
        ...balanceUsage,
        remainingPayment: parseInt(amountToBePaid),
      });
    }

  };

  // SET ATOME PRICE
  const handleSetAtomePrice = (amount) => {
    const { asking_price = 0, total_subsidy = 0 } = _sell || {};
    const price = amount ? amount : _getTotal()
    setAtomePrice(Math.ceil(price / 3));
  };

  const handleFetchKredivoInstallments = (amount) => {
    const { id: user_sell_id, product_variant = {}, asking_price } =
      dataInprogress.sell || {};
    const { id, display_name: name } = product_variant || {};
    const item = {
      id,
      user_sell_id,
      name,
      price: parseInt(asking_price),
      quantity: 1,
    };
    const newAmount = amount === undefined ? _getTotal() : amount;
    doGetKredivoInstallments(item, newAmount);
    doGetAkulakuInstallments(item);
  };

  //handle ERROR MESSAGES
  function printError(e) {
    let errorMessage = "";

    if (!e) return;

    if (!e.errors) {
      if (e.error && e.error.message) errorMessage = e.error.message;
      else errorMessage = e.message;
    } else {
      let { errors } = e;

      for (let idx in errors) {
        let message = errors[idx];

        if (message instanceof Array) {
          message.map((m) => {
            if (m instanceof Object) errorMessage += m.message + "\n";
            else errorMessage += m + "\n";
          });
        } else {
          errorMessage += message + "\n";
        }
      }
    }

    if (errorMessage.includes("timeout"))
      errorMessage =
        "It’s taking too long to load, please check your internet connection and try again";

    if (errorMessage.includes("Token has expired"))
      errorMessage = "Sorry, your session has expired. Please login again.";

    if (errorMessage.includes("Token not provided"))
      errorMessage = "Sorry, your session has expired. Please login again.";

    if (errorMessage.includes("Shoes stock is not enough"))
      errorMessage =
        "Sorry! Your product is no longer available. Please press Refresh to get the latest prices.";

    return errorMessage;
  }

  const handleChoosePayment = (args) => {
    const { cost, error = null, status_code } = couriers || {};
    if (error) {
      if (error.status_code >= 500) {
        setPopUpErrorMessage("Sorry, we have a problem!. Please inform our friendly staff via Whatsapp +6281210005425")
      } else {
        setPopUpErrorMessage(printError(error))
      }
      setIsErrorModalOpen(true)
    } else {
      !fetchShippingFee && setCheckoutProcess(args)
    }
  }

  const getOtpHandler = () => {
    if (checkIfExpired()) {
      getOtp()
    } else {
      setOtpErrorMsg("")
      setGettingOtp(false)
      setShowModalOtp(true)
    }
  }

  /* ------SUBMIT BUYING------- */
  const handleSubmit = (otpCode) => {
    setIsSubmit(true)
    setIsLoadingSubmit(true)
    const kaCourierOption = _additionalProducts
      .filter((item) => item.isSelected)
      .map((item) => item.name)
      .join(" + ");

    const totalAddOnPrice = totalAddOnProduct + _shippingFee;
    const { asking_price: offerAmount, id: sellId, subsidy_price } = _sell;
    const totalUsageWallet = (() => {
      const { sellerCredit, kickCredit, kickPoint } = balanceUsage || {};
      return currentPaymentMethod.payment_method === "full_wallet"
        ? sellerCredit + kickCredit + kickPoint
        : 0;
    })();

    // SHIPPING FEE PAYLOAD
    const completeSelectedAddressInfo =
      shippingHistory.data &&
      shippingHistory.data.length > 0 &&
      shippingHistory.data.filter((postal) => selectedAddress.id === postal.id);
    const phoneNumber =
      countries.data &&
      countries.data.length > 0 &&
      countries.data.filter(
        (country) => country.code3 === selectedAddress.country
      );
    const provinceId =
      provinces.data &&
      provinces.data.length > 0 &&
      provinces.data.filter(
        (province) => province.name === selectedAddress.province
      );
    const cityId =
      cities.data &&
      cities.data.length > 0 &&
      cities.data.filter((city) => city.name === selectedAddress.city);

    const shippingPayload = {
      id: completeSelectedAddressInfo[0].id,
      alias: completeSelectedAddressInfo[0].alias,
      full_name: completeSelectedAddressInfo[0].full_name,
      phone_number: completeSelectedAddressInfo[0].phone_number,
      street_address: completeSelectedAddressInfo[0].street_address,
      note: completeSelectedAddressInfo[0].note,
      country: completeSelectedAddressInfo[0].country,
      province: completeSelectedAddressInfo[0].province,
      province_id: provinceId.length > 0 && provinceId[0].id,
      city: completeSelectedAddressInfo[0].city,
      city_id: cityId.length > 0 ? cityId[0].id : null,
      postal_code: completeSelectedAddressInfo[0].postal_code,
    };

    const isOnlyKickPoint = product?.variant_payment_methods?.length === 1 && !!product?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point");

    const current_payment_method = selectedSplitPaymentMethod ? selectedSplitPaymentMethod : currentPaymentMethod

    const selected_kredivo_installment = selectedSplitKredivoInstallment ? selectedSplitKredivoInstallment.value : selectedKredivoInstallment

    const facebook_ad_campaign = localStorage.getItem("facebook_ad_campaign");
    const fb_campaign_id = facebook_ad_campaign ? JSON.parse(facebook_ad_campaign, 2, null) : null

    const dataPayload = {
      shipping: shippingPayload,
      user_sell_id: sellId,
      quantity: 1,
      payment_method: isOnlyKickPoint? "kick_point" : current_payment_method.payment_method,
      ka_courier_price: totalAddOnPrice,
      currency: "IDR",
      offer_amount: offerAmount,
      unique_amount: 0,
      administration_fee: 0,
      ka_courier_option: kaCourierOption ? kaCourierOption : "FLAT_RATE",
      wallet_amount: totalUsageWallet,
      subsidy_price: parseInt(subsidy_price || 0),
      point_enabled: isKickPointActive,
      facebook_ad_campaign: fb_campaign_id ? fb_campaign_id.facebook_ad_campaign : fb_campaign_id
    };

    if (otpCode) {
      dataPayload.otp = otpCode
    }

    if (collection_id) {
      dataPayload.collection_id = collection_id
    }

    if (_voucherValidated) {
      const { code, deduct_type } = _voucherValidated;
      dataPayload["voucher_code"] = code;

      if (!isCashback) {
        switch (deduct_type) {
          case VOUCHER_PRODUCT_TYPE:
            dataPayload["discount"] = _discount;
            break;
          case VOUCHER_COURIER_TYPE:
            dataPayload["ka_courier_discount"] = _discount;
            break;
        }
      }
    }

    if (current_payment_method.payment_method === KREDIVO) {
      dataPayload["installments_type"] = selected_kredivo_installment;
    }

    (async (cb) => {
      await set_SubmitPayment(true);
      await set_Processed(false);
      await setError(null);
      cb();
    })(() => {
      if (current_payment_method.label === "BCA Card" || current_payment_method.payment_method === BCA_CREDIT_CARD) {
        // submitSprintAsiaPayment(dataPayload)
        //TEMPORARY SWITCHED TO MIDTRANS SINCE SPRINTASIA HAS ISSUE WITH DEBIT CARD
        submitMidtransPayment(dataPayload)
        return;
      }

      const shippingCountry = selectedAddress?.country || 'IDN'

      switch (current_payment_method.payment_method) {
        case VIRTUALACCOUNT:
          submitXenditPayment(dataPayload);
          break;
        case CREDITCARD:
          if (shippingCountry !== 'IDN' || !isIndonesian) {
            submitXenditPayment(dataPayload);
          } else {
            submitMidtransPayment(dataPayload);
          }
          break;
        case BCA_INSTALLMENTS:
        case BCA_VA:
        case BRI_VA:
        case PERMATA_VA:
        case BNI_VA:
        case MANDIRI_VA:
        case MANDIRI_CREDIT_CARD:
        case MANDIRI_DEBIT_CARD:
        case BNI_CREDIT_CARD:
        case BNI_DEBIT_CARD:
        case GOPAY:
          submitMidtransPayment(dataPayload);
          break;
        case KREDIVO:
          submitKredivoPayment(dataPayload);
          break;
        case AKULAKU:
          submitAkulakuPayment(dataPayload);
          break;
        case ATOME:
          submitAtomePayment(dataPayload);
          break;
        case FULLWALLET:
        default:
          submitPayment(dataPayload);
          break;
      }
    });
  };
  /* ------======END OF SUBMIT BUYING PROCESS=======------- */
  /* ------------------END OF VOUCHERS METHOD------------------------------ */

  /* LIFECYCLE HOOKS */
  // Component did mount
  useEffect(() => {
    getUserVoucher();
    fetchKredivoInstallments();

    const setPayment = [];
    const { variant_payment_methods } = product;
    if (variant_payment_methods && variant_payment_methods.length > 0) {
      let dataPayments = _paymentMethods.map((payments) => {
        var variantPaymentMethod = Object.assign({}, payments);
        variant_payment_methods.find((item) => {
          const isSetPayment = setPayment.includes(item.payment_method)
            ? setPayment
            : setPayment.push(item.payment_method);
          if (!setPayment.includes(payments.payment_method))
            variantPaymentMethod.active = false;
          else variantPaymentMethod.active = true;
        });
        return variantPaymentMethod;
      });

      const paymentType =
        setPayment.length && setPayment.includes(BCA_VA)
          ? BCA_VA
          : setPayment.length && setPayment.includes(BANKTRANSFER)
            ? BANKTRANSFER
            : setPayment.length
              ? setPayment[0]
              : null;
      
      const isOnlyKickPoint = variant_payment_methods?.length === 1 && !!variant_payment_methods?.find((item) => item?.payment_method === "kick_point");

      if (isOnlyKickPoint) {
        dataPayments = dataPayments.map((item) => {
          if (item?.payment_method === "full_wallet") {
            return {
              ...item,
              active: true
            }
          } else return item;
        })
      }

      setPaymentMethods(dataPayments);
      setPaymentType(paymentType)
    }
  }, []);

  //After submit payment to api done.
  useEffect(() => {
    if (!_submitPayment) return;
    const { error } = dataPayments.payments;
    if (error) {
      const printErrorMsg = printError(error)
      const { errors, status_code } = error;
      if (errors && status_code === 422) {
        const errorOfferAmount = Object.keys(errors).find(
          (key) => key === "offer_amount"
        );
        if (errorOfferAmount) {
          let _isValidVoucherTemp = _isValidVoucher;
          const newAskingPrice = parseFloat(errors.offer_amount[1].ERROR_VAR);
          const { balance } = userdata;

          let _discount = 0;

          if (_isValidVoucherTemp && _voucherValidated !== null) {
            const { minimum_purchase } = _voucherValidated;
            if (parseFloat(minimum_purchase) > newAskingPrice)
              _isValidVoucherTemp = !_isValidVoucherTemp;
            else
              _discount = _getVoucherAmount(
                _voucherValidated,
                newAskingPrice,
                _shippingFee
              );
          }

          const administrationFee = _getAdmFee(
            paymentType,
            newAskingPrice,
            _shippingFee,
            _discount
          );

          if (balance < newAskingPrice) {
            setWalletPayment(false);
            set_KickAmount(0);
            setPaymentType(BANKTRANSFER);
          }

          set_Sell({
            ..._sell,
            asking_price: newAskingPrice,
          });
          set_Discount(_discount);
          set_AdministrationFee(administrationFee);
          set_IsValidVoucher(_isValidVoucherTemp);
          set_VoucherValidated(_isValidVoucherTemp ? _voucherValidated : null);
          set_VoucherInput(_isValidVoucherTemp ? _voucherInput : "");
          set_ModalOutOfStockMsg(PRICE_CHANGED_MSG);
          set_AskingPriceStatus(
            asking_price < newAskingPrice ? ASKING_PRICE_UP : ASKING_PRICE_DOWN
          );
          set_KickAmount(0);
          if (isOtpActive && typeof printErrorMsg === "string" && printErrorMsg.toLocaleLowerCase().includes("otp")) {
            setShowModalOtp(true)
          }
        }
      } else if (status_code === 404) {
        setIsOpenOutOfStockModal(true);
        set_ModalOutOfStockMsg(OUT_OF_STOCK_MSG);
      }

      let hasMessageCustom = false;
      let message = error.message;
      if (error.status_code === 500) {
        if (
          message === "User has wallet payment or disbursement still pending."
        ) {
          message =
            "Sorry, your request cannot be processed. You still have wallet payment or cash out pending.";
          hasMessageCustom = true;
        }
      }

      setError({
        ...dataPayments.payments.error,
        message,
        hasMessageCustom,
      });

      set_SubmitPayment(!_submitPayment);
      setPopUpErrorMessage(printErrorMsg === "Invalid OTP" ? "" : printErrorMsg)
      setIsErrorModalOpen(printErrorMsg === "Invalid OTP" ? false : true)
      setOtpErrorMsg(printErrorMsg === "Invalid OTP" ? printErrorMsg : "")

      if (isOtpActive && typeof printErrorMsg === "string" && printErrorMsg.toLocaleLowerCase().includes("otp")) {
        setShowModalOtp(true)
      }
      setIsSubmit(false)
      setIsLoadingSubmit(false)
    } else {
      const { invoice_number, payment_gateway, payment_via } =
        dataPayments.payments.data || {};
      if (payment_via === "vt") {
        resetOtpFromLocalstorage()
        setIsSubmit(false)
        setIsLoadingSubmit(false)
        setShowModalOtp(false)
        set_SnapPay({
          isOpen: true,
          invoiceNumber: invoice_number,
          trxToken: payment_gateway.transaction_token,
          externalUrl: payment_gateway.redirect_url,
          expiredAt: payment_gateway.expired_at,
          redirectUrl: `/invoices/${invoice_number}?trx_id=${payment_gateway.transaction_token}`,
          _processed: true,
          _shouldRedirect: true,
        });
      } else {
        (async () => {
          const { invoice_number, invoice_url } =
            dataPayments.payments.data || {};
          await set_Processed(true);
          await set__ShouldRedirect(true);
          resetOtpFromLocalstorage()
          if (paymentType === BANKTRANSFER || paymentType === FULLWALLET)
            setTimeout(() => {
              _redirectBankTransfer(invoice_url, invoice_number)
              setIsSubmit(false)
              setIsLoadingSubmit(false)
            }, 3000);
          else
            setTimeout(() => {
              _redirectPayment(invoice_url, invoice_number)
              setIsSubmit(false)
              setIsLoadingSubmit(false)
            }, 3000);
        })();
      }
    }
  }, [dataPayments.payments.data]);

  //After checking voucher availables done.
  useEffect(() => {
    const { voucher } = dataPayments;
    const { asking_price, subsidy_price } = _sell;

    if (voucher.status_code === 200) {
      const {
        code,
        type,
        amount,
        deduct_type,
        minimum_purchase,
        max_amount,
        is_cashback,
        potentially_cashback
      } = voucher.data;

      const _discountTemp = _getVoucherAmount(
        { code, type, amount: is_cashback ? potentially_cashback : amount, deduct_type, max_amount },
        asking_price - parseInt(subsidy_price || 0),
        _shippingFee
      );

      const adminFeeTemp = _getAdmFee(
        paymentType,
        asking_price,
        _shippingFee,
        _discountTemp
      );

      const voucherValidatedPayload = {
        code,
        type,
        amount: is_cashback ? potentially_cashback : amount,
        deduct_type,
        minimum_purchase,
        max_amount,
      };

      const isCreditOnly = EVENT_VOUCHER.includes(
        _voucherInput && _voucherInput.toUpperCase()
      )
        ? true
        : false;

      setIsCashback(is_cashback)
      set_IsValidVoucher(true);
      set_VoucherValidated(voucherValidatedPayload);
      set_AdministrationFee(adminFeeTemp);
      set_Discount(_discountTemp);
      setCreditDebitOnly(isCreditOnly);
    } else {
      let _error = null;
      switch (voucher.error && voucher.error.status_code) {
        case 422:
          _error = {
            errors: {
              _voucherInput: Object.keys(voucher.error.errors)
                .filter((err) => err === "code")
                .map((err) => {
                  if (
                    voucher.error.errors[err][0] ===
                    "Voucher can only use on app."
                  ) {
                    return [
                      "Sorry this voucher can only apply through our application. You can download it in App Store or Play Store.",
                    ];
                  }
                  return voucher.error.errors[err];
                }),
            },
            status_code: 422,
          };
          break;
        case 404:
          _error = {
            errors: {
              _voucherInput: ["Voucher tidak ditemukan."],
            },
            status_code: 422,
          };
          break;
        default: {
          _error = {
            errors: {
              _voucherInput: [
                "Oopss ada error. Please inform our staff via our official Line account.",
              ],
            },
          };
          break;
        }
      }

      if (voucher.error) {
        setPopUpErrorMessage(printError(voucher.error))
        setIsErrorModalOpen(true)
        setIsSubmit(false)
        setIsLoadingSubmit(false)
      }

      setError(_error);
      set_Discount(0);
      set_VoucherInput("");
      set_VoucherValidated(null);
      set_IsValidVoucher(false);
    }
  }, [dataPayments.voucher]);

  useEffect(() => {
    const {
      payments = {}
    } = dataPayments || {}

    const {
      error
    } = payments || {}

    if (error) {
      const printErrorMsg = printError(error)
      setPopUpErrorMessage(printErrorMsg === "Invalid OTP" ? "" : printErrorMsg)
      setIsErrorModalOpen(printErrorMsg === "Invalid OTP" ? false : true)
      setOtpErrorMsg(printErrorMsg === "Invalid OTP" ? printErrorMsg : "")
      setIsSubmit(false)
      setIsLoadingSubmit(false)
      const current_payment_method = selectedSplitPaymentMethod ? selectedSplitPaymentMethod : currentPaymentMethod;
      const totalUsageWallet = (() => {
        const { sellerCredit, kickCredit, kickPoint } = balanceUsage || {};
        return currentPaymentMethod.payment_method === "full_wallet"
          ? sellerCredit + kickCredit + kickPoint
          : 0;
      })();
      if (current_payment_method?.payment_method !== "full_wallet" && !totalUsageWallet) {
        return
      }

      if (isOtpActive && typeof printErrorMsg === "string" && printErrorMsg.toLocaleLowerCase().includes("otp")) {
        setGettingOtp(false)
        setShowModalOtp(true)
      }
    } else {
      setPopUpErrorMessage("")
      setOtpErrorMsg("")
      setIsErrorModalOpen(false)
    }
  }, [dataPayments.payments])

  // GET PRODUCT ADD ON
  useEffect(() => {
    if (!productAddon.data || productAddon.data.length === 0) return;

    const { data, error, status_code } = productAddon;

    if (!error && status_code === 200 && data) {
      const addonManipulates = data.map((item) => {
        let addons = Object.assign({}, item);
        addons.isSelected = false;
        addons.price = parseInt(item.price);
        addons.displayName = item.display_name;
        addons.signedUrl = item.img_url;
        if (item.categories.length > 0) {
          let newCategory = [];
          item.categories.map((category) => {
            newCategory.push(category.name.toLowerCase());
          });
          addons.visible = newCategory;
        } else addons.visible = "*";
        return addons;
      });
      setAddOnProduct(addonManipulates);
    }

    if (error) {
      setPopUpErrorMessage(printError(error))
      setIsErrorModalOpen(true)
    }
  }, [productAddon]);

  // SET SHIPPING
  useEffect(() => {
    const {
      id: initShippingId,
      alias: initAlias,
      full_name: initFullName,
      street_address: initStreetAddress,
      city: initCity,
      province: initProvince,
      postal_code: initPostalCode,
      country: initCountry,
    } = shippingHistory.data ? shippingHistory.data.length > 0 ? shippingHistory.data[0] : {} : {};

    setSelectedAddress({
      id: initShippingId,
      alias: initAlias,
      full_name: initFullName,
      street_address: initStreetAddress,
      city: initCity,
      province: initProvince,
      postal_code: initPostalCode,
      country: initCountry,
      isAddressNotNull: shippingHistory?.data?.length > 0 ? true : false
    });
  }, [shippingHistory.data]);

  // GET SHIPPING FEE && TOGGLE UMBRE ENABLED
  useEffect(() => {
    (async () => {
      const { data = [] } = provinces || {};
      const { province = "", country = "", city = "" } = selectedAddress || "";

      let provinceId = null;
      let cityId = null;
      await getProvinces(country).then(({ value }) => {
        const { data = [] } = value || {};
        if (data.length === 0 || !province) return;

        const currentProvinceId = data.filter(
          (datum) => datum.name === province
        );
        provinceId =
          Array.isArray(currentProvinceId) && currentProvinceId.length > 0
            ? currentProvinceId[0].id
            : null;
        set__ProvinceSelected(provinceId);
      });

      await getCities(country, province).then(({ value }) => {
        const { data = [] } = value || {};
        if (data.length === 0 || !city) return;

        const currentCityId = data.filter((datum) => datum.name === city);

        cityId =
          Array.isArray(currentCityId) && currentCityId.length > 0
            ? currentCityId[0].id
            : null;
      });

      // 1. CALCAULATE SHIPPING FEE
      await _calculateShippingFee(provinceId);

      // 2. Toggle Umbre Enabled
      const isUmbreEnable = await validateUmbre(provinceId, cityId);
      await set_UmbreEnabled(isUmbreEnable);

      await getProvinces(country);
      await getCountries();
      await getCities(country, province);
    })();
  }, [selectedAddress]);

  useEffect(() => {
    const { cost, error = null } = couriers || {};
    const { destination = [] } = (error && error.errors) || {};

    if (destination.length > 0) {
      setErrMessages([...destination, ...errMessages]);
      return;
    }

    if (error) {
      if (error.status_code >= 500) {
        setPopUpErrorMessage("Sorry, we have a problem!. Please inform our friendly staff via Whatsapp +6281210005425")
      } else {
        setPopUpErrorMessage(printError(error))
      }
      setIsErrorModalOpen(true)
    }
    set_ShippingFee(cost);
  }, [couriers]);

  useEffect(() => {
    fetchKredivoInstallments();
  }, [dataPayments.kredivoAvailableInstallment]);

  // COUNT USAGE OF SELLER CREDIT, KICK CREDIT ON SPLIT PAYMENT SUMMARY
  useEffect(() => {
    amountToBePaid > 1 && handleUsageBalance();
  }, [amountToBePaid]);

  // DETECT ANY ERROR OCCURED
  useEffect(() => {
    if (isErrorModalOpen) {
      setTimeout(() => {
        setIsErrorModalOpen(false);
        setIsSubmit(false);
      }, 3000);
    }
  }, [isErrorModalOpen]);

  useEffect(() => {
    if (otpStatus?.data?.pay_with_wallet) {
      setIsOtpActive(otpStatus.data.pay_with_wallet)
    } else {
      setIsOtpActive(false)
    }
  }, [otpStatus?.data?.pay_with_wallet])

  useEffect(() => {
    if (otpCode.success) {
      setOtpErrorMsg("")
      setGettingOtp(false)
      saveResendOtpToLocalStorage()
      setShowModalOtp(true)
      saveToLocalStorage()
    } else if (otpCode?.message) {
      setOtpErrorMsg(otpCode?.message)
      setGettingOtp(false)
      setShowModalOtp(true)
    } else {
      setOtpErrorMsg("")
    }
  }, [otpCode])

  useEffect(() => {
    resetOtpState()
    getOtpStatus()
  }, [])

  const availableMethods = _paymentMethods.map((item) => {
    if (creditDebitOnly) {
      if (
        item.payment_method === DEFAULT_CREDIT_CARD ||
        item.payment_method === CREDITCARD ||
        item.payment_method === BCA_VA ||
        item.payment_method === BCA_INSTALLMENTS
      ) {
        return {
          ...item,
          active: true,
        };
      }
      return { ...item, active: false };
    } else return item;
  });

  const isIndonesian = userdata.country_code === "IDN";
  const propertyForCheckoutPage = {
    sell,
    size,
    productCondition,
    etaText,
    asking_price,
    dataPostalCode,
    getHistoryShipping,
    dataAuth,
    dataCart,
    dataPayments,
    productAddon,
    getShippingFee,
    getUserVoucher,
    dataVoucher,
    backToDetailsPage,
    dataAkulaku,
    doGetKredivoInstallments,
    doGetAkulakuInstallments,
    selectedSize,
    dataInprogress,
    getProvinces,
    dataProvinces,
    getCities,
    getCountries,
    submitXenditPayment,
    submitMidtransPayment,
    submitKredivoPayment,
    submitAkulakuPayment,
    submitAtomePayment,
    submitPayment,
    productImage:
      (thumbnailsProps &&
        Array.isArray(thumbnailsProps) &&
        thumbnailsProps.length > 0 &&
        thumbnailsProps[0].URL) ||
      "",
    product,
    _snapPay,
    isErrorModalOpen,
    currentPaymentMethod,
    isOpenOutOfStockModal,
    propsHistory: props.history,
    popUpErrorMessage,
    checkoutProcess,
    addOnSelected,
    category,
    display_name,
    size,
    productCondition,
    etaText,
    asking_price,
    buyNowPrice,
    filteredAddOnProduct,
    _umbreEnabled,
    _handleAdditionalChange,
    _getLayananPrice,
    _shippingFee,
    selectedVoucherCode,
    _discount,
    _sell,
    totalAddOnProduct,
    _getTotal,
    selectedAddress,
    isAddressBookOpen,
    shippingHistory,
    countries,
    cities,
    provinces,
    shippingId,
    changeId,
    submitShipping,
    getHistoryShipping,
    setOpenVoucherModal,
    handleClearVoucher,
    _handleSelectedAddress,
    handleModalAddressToggle,
    handleSelectedVoucherCode,
    setIsErrorModalOpen,
    setCheckoutProcess: (args) => {
      if (args === "choose-payment") {
        handleChoosePayment(args)
      } else {
        setCheckoutProcess(args)
      }
    },
    setAmountToBePaid,
    handleFetchKredivoInstallments,
    handleSetAtomePrice,
    defaultId,
    dataVoucher,
    isAddressButtonDisable,
    openVoucherModal,
    amountToBePaid,
    balance,
    dataAkulaku,
    totalBalance,
    isIndonesian,
    balanceUsage,
    creditDebitOnly,
    balance_with_fee,
    availableMethods,
    _installmentsList,
    setIsSplitPayment,
    setCurrentPaymentMethod,
    atomePrice,
    isSplitPayment,
    locked_balance,
    kickCreditProcess,
    isKickPointActive,
    isOpenModalBalanceInfo,
    selectedSplitPaymentMethod,
    selectedSplitKredivoInstallment,
    handleSubmit: () => {
      if (!isOtpActive) {
        handleSubmit()
        return
      }
      const current_payment_method = selectedSplitPaymentMethod ? selectedSplitPaymentMethod : currentPaymentMethod
      const totalUsageWallet = (() => {
        const { sellerCredit, kickCredit, kickPoint } = balanceUsage || {};
        return currentPaymentMethod.payment_method === "full_wallet"
          ? sellerCredit + kickCredit + kickPoint
          : 0;
      })();

      if (current_payment_method?.payment_method !== "full_wallet" && !totalUsageWallet) {
        handleSubmit()
        return
      }
      getOtpHandler()
    },
    handleUsageBalance,
    setIsKickPointActive,
    setKickCreditProcess,
    setIsModalBalanceInfo,
    setSelectedSplitPaymentMethod,
    setSelectedSplitKredivoInstallment,
    isSubmit,
    errMessages,
    selectedKredivoInstallment,
    setSelectedKredivoInstallment,
    set_SnapPay,
    isLoadingSubmit,
    setIsLoadingSubmit,
    isKickCreditActive,
    setIsKickCreditActive,
    userCurrency,
    isCashback,
    isFetchCourier: fetchShippingFee,
    isUseVoucher,
    voucher_applicable: sell.product_variant.voucher_applicable,
    voucherEnabledPayments
  };

  return (
    <>
      {showModalOtp ? <ModalOtp
        show={showModalOtp}
        onHide={() => {
          setShowModalOtp(!showModalOtp)
          resetOtpState()
          setOtpErrorMsg("")
        }}
        email={userData?.email ?? ""}
        submitOtp={(otpCode) => {
          setOtpErrorMsg("")
          setShowModalOtp(false)
          handleSubmit(otpCode)
        }}
        resendCode={() => {
          // getOtpHandler()
          getOtp()
          setGettingOtp(true)
          resendOtp()
        }}
        gettingOtp={gettingOtp}
        errorMsg={otpErrorMsg}
        currentProcess={currentProcess}
        backAction={() => {
          setShowModalOtp(false)
          resetOtpState()
          setOtpErrorMsg("")
        }}
      /> : null}

      {
        (width >= 1024)
          ? <CheckoutPageDekstopView
            propertyForCheckoutPage={propertyForCheckoutPage}
          /> : <CheckoutPageResponsiveView propertyForCheckoutPage={propertyForCheckoutPage} />
      }
    </>
  )
}

const mapStateToProps = (state) => ({
  dataCountries: state.dataPostalCode.countries,
  dataProvinces: state.dataPostalCode.provinces,
  dataCities: state.dataPostalCode.cities,
  dataCouriers: state.dataPostalCode.couriers,
  dataPostalCode: state.dataPostalCode,
  dataPayments: state.dataPayment,
  dataAuth: state.dataAuth,
  userCurrency: state.dataAuth.userCurrency,
  dataCategory: state.dataCategory,
  voucherCode: state.dataPayment.voucherCode,
  currency: state.dataAuth.userCurrency.currency,
  productAddon: state.dataPayment.productAddon,
  dataVoucher: state.dataKickPoint.userVoucher,
  dataAkulaku: state.dataPayment.akulakuAvailableInstallment.data,
  userData: state.dataAuth.userdata,
  otpCode: state.dataAuth.otpCode,
  otpStatus: state.dataAuth.otpStatus
});

const mapDispatchToProps = (dispatch) => ({
  getCountries: () => dispatch(doFetchCountries()),
  getProvinces: (country) => dispatch(doFetchProvinces(country)),
  getCities: (country = "", province = "") =>
    dispatch(doFetchCities(country, province)),
  getShippingFee: (payload) => dispatch(doPostShippingCost(payload)),
  submitPayment: (payload) => dispatch(doPostPayments(payload)),
  submitXenditPayment: (payload) => dispatch(doPostXenditPayment(payload)),
  submitMidtransPayment: (payload) => dispatch(doPostMidtransPayment(payload)),
  //TODO: Akulaku
  submitAkulakuPayment: (payload) => dispatch(doPostAkulakuPayment(payload)),
  submitAtomePayment: (payload) => dispatch(doPostAtomePayment(payload)),
  applyVoucher: (payload) => dispatch(doPostApplyVoucher(payload)),
  doGetVoucherCode: (keyword) => dispatch(doGetVoucherCode(keyword)),
  doFetchProductAddon: (payload) => dispatch(doFetchProductAddon(payload)),
  getHistoryShipping: () => dispatch(getHistoryShipping()),
  getUserVoucher: () => dispatch(getUserVoucher()),
  doGetKredivoInstallments: (product, amount) =>
    dispatch(doPostKredivoAvailableInstallments(product, amount)),
  submitKredivoPayment: (payload) => dispatch(doPostKredivoPayment(payload)),
  submitSprintAsiaPayment: (payload) => dispatch(doPostSprintasiaPayment(payload)),
  doGetAkulakuInstallments: (product) =>
    dispatch(doPostAkulakuAvailableInstallments(product)),
  getOtp: () => dispatch(getOtp()),
  resetOtpState: () => dispatch(resetOtpState()),
  getOtpStatus: () => dispatch(getOtpStatus()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CheckoutPage));
